import { render } from "./calendar-scheduling.vue?vue&type=template&id=3dfcb10a&lang=pug"
import script from "./calendar-scheduling.vue?vue&type=script&lang=js"
export * from "./calendar-scheduling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__